@if (alertIgnorarErros === true) {
  <div class="body-alert">
    <div class="div-alert text-center">
      <img class="imagem" src="/assets/img/inconsistencia.png" width="72px" alt="Inconsistencia na pagina">
      <div>
        <p class="subtitulo-alert">Ao ignorar os erros, <u>somente os benefícios listados</u> não será incluídos no pedido. Para avançar emita o relatório disponível no link "Baixar todos os erros encontrados".
        Atenção: para os usuários listados no CSV, que tenham mais de um benefício <u>haverá emissão do pedido normalmente</u> por não possuir inconsistências.</p>
      </div>
      <div class="div-botoes">
        <button class="botao-outline" (click)="alertAlertIgnorarErrosFechou()">FECHAR</button>
      </div>
    </div>
  </div>
}
